import { BLOG_PATHS } from "@/data/blog-paths";
import { chipById, postInAgeChip, type AgeChipId } from "./age-bands";

export type PathPost = { slug: string; age_band: unknown; published_at: string | null };

const time = (p: PathPost) => (p.published_at ? new Date(p.published_at).getTime() : 0);

/** Posts in the chip: configured slugs first, in order, then the rest newest first. */
export function orderPath<T extends PathPost>(chipId: AgeChipId, posts: T[], config = BLOG_PATHS): T[] {
  const chip = chipById(chipId);
  const matching = posts.filter((p) => postInAgeChip(p.age_band, chip));
  const bySlug = new Map(matching.map((p) => [p.slug, p]));
  const head: T[] = [];
  for (const slug of config[chipId] ?? []) {
    const p = bySlug.get(slug);
    if (p && !head.includes(p)) head.push(p);
  }
  const rest = matching.filter((p) => !head.includes(p)).sort((a, b) => time(b) - time(a));
  return [...head, ...rest];
}
